import {
  type TypographyProps,
  type TypographyTextProps,
} from '@/core/tamagoshiTailwind/components/Typography/Typography';

import { type PriceProps } from './Price.interfaces';

export const priceVariantParams: Record<
  PriceProps['size'],
  {
    priceScale: TypographyProps['scale'];
    typoScale: TypographyTextProps['scale'];
    vatScale: TypographyTextProps['scale'];
  }
> =
  // prettier-ignore
  {
    XS:  { priceScale: 'body2',  typoScale: 'small', vatScale: 'tiny'  },
    S:   { priceScale: 'body1',  typoScale: 'body2', vatScale: 'tiny'  },
    M:   { priceScale: 'title4', typoScale: 'body2', vatScale: 'tiny'  },
    L:   { priceScale: 'title3', typoScale: 'body2', vatScale: 'small' },
    XL:  { priceScale: 'title3', typoScale: 'body1', vatScale: 'small' },
    XXL: { priceScale: 'title1', typoScale: 'body1', vatScale: 'body2' },
  };
